app.factory('templateModel', ['$rootScope', '$q', 'baseModel', 'templateService',
    function($rootScope, $q, baseModel, templateService) {

	    function TemplateModel() {
	
		   	this.getDataPage = function(criteria) {
		   		return templateService.getDataPage(criteria).then(
		   			function (dataPage) {
		   				$rootScope.$broadcast(Event.TEMPLATE.GET_DATA_PAGE.SUCCESS, dataPage);
						return dataPage;
		   			},
		   			function(error) {
		   				$rootScope.$broadcast(Event.TEMPLATE.GET_DATA_PAGE.ERROR, error);
						return $q.reject(error);
		   			}
		   		)
		    };
		    
		    this.getById = function(id) {
		   		return templateService.getById(id).then(
			   		function (template) {
			   			$rootScope.$broadcast(Event.TEMPLATE.GET_BY_ID.SUCCESS, template);
                        return template;
			   		},
			   		function(error) {
			   			$rootScope.$broadcast(Event.TEMPLATE.GET_BY_ID.ERROR, error);
                        return $q.reject(error);
			   		}
			   	)
		    };

            this.save = function(template) {
                return templateService.save(template).then(
                    function (savedTemplate) {
                        $rootScope.$broadcast(Event.TEMPLATE.SAVE.SUCCESS, savedTemplate);
                        baseModel.broadcastOperationSucceeded();
                        return savedTemplate;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.TEMPLATE.SAVE.ERROR, error);
                        baseModel.broadcastOperationFailed();
                        return $q.reject(error);
                    }
                )
            };

            this.saveFromVisitCard = function(visitCardId, template) {
                return templateService.saveFromVisitCard(visitCardId, template).then(
                    function (savedTemplate) {
                        baseModel.broadcastOperationSucceeded();
                        return savedTemplate;
                    },
                    function(error) {
                        baseModel.broadcastOperationFailed();
                        return $q.reject(error);
                    }
                )
            };

            this.update = function(template) {
                return templateService.update(template).then(
                    function (savedTemplate) {
                        $rootScope.$broadcast(Event.TEMPLATE.UPDATE.SUCCESS, savedTemplate);
                        baseModel.broadcastOperationSucceeded();
                        return savedTemplate;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.TEMPLATE.UPDATE.ERROR, error);
                        baseModel.broadcastOperationFailed();
                        return $q.reject(error);
                    }
                )
            };
		
		    this.delete = function(template) {
		   		return templateService.delete(template).then(
			   		function (data) {
			   			$rootScope.$broadcast(Event.TEMPLATE.DELETE.SUCCESS, data);
		                baseModel.broadcastOperationSucceeded();
                        return data;
			   		},
			   		function(error) {
			   			$rootScope.$broadcast(Event.TEMPLATE.DELETE.ERROR, error);
		                baseModel.broadcastOperationFailed();
                        return $q.reject(error);
			   		}
			   	)
		    };
	
	    }
	
	    return new TemplateModel();
	}
]);
